/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextActionPlusIcon64Regular = forwardRef('TextActionPlusIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M8 12.5A1.5 1.5 0 0 1 9.5 11h45a1.5 1.5 0 0 1 0 3h-45A1.5 1.5 0 0 1 8 12.5Z" }),
        React.createElement("path", { d: "M9.5 25a1.5 1.5 0 0 0 0 3h45a1.5 1.5 0 0 0 0-3h-45Z" }),
        React.createElement("path", { d: "M9.5 39a1.5 1.5 0 0 0 0 3h19a1.5 1.5 0 0 0 0-3h-19Z" }),
        React.createElement("path", { d: "M49 37a1.5 1.5 0 0 0-3 0v9h-9a1.5 1.5 0 0 0 0 3h9v9a1.5 1.5 0 0 0 3 0v-9h9a1.5 1.5 0 0 0 0-3h-9v-9Z" })));
});
